<section class="request-extension-dialog">
  <div class="uscb-layout-row uscb-bg-primary uscb-color-white">
      <span class="vcenter uscb-flex uscb-padding-TB-0 uscb-padding-LR-8">{{surveySelectionDialogData.title}}</span>
      <span class="vcenter">
          <mat-icon (click)="close(true)" (keyup.enter)="close(true)" tabindex="0" aria-hidden="false">close</mat-icon>
      </span>
  </div>


  <mat-dialog-content>
    <div class="uscb-layout-column">
      <h4 class="xlg-text uscb-layout-column uscb-layout-align-vert-center uscb-text-align-center">Which Surveys Do You Want to Export?</h4>
      <div class="uscb-layout-column uscb-padding-TB-10">
        <button (click)="clearForm()" (keyup.enter)="clearForm()" class="uscb-transparent-button uscb-margin-0 uscb-padding-TB-0 uscb-paddding-LR-5" type="button">
          <span>Clear</span>
        </button>
      </div>
      
      <div class="uscb-layout-column uscb-layout-align-center uscb-layout-align-vert-center cmp-form">
        <fieldset class="cmp-form-options cmp-form-options--checkbox" id="exportSurveyTypesList" [formGroup]="surveyForm">
            @for (survey of currentSurveys(); track survey) {
            <div class="cmp-form-options--checkbox">
                <label class="cmp-form-options__field-label">
                    <input class="cmp-form-options__field cmp-form-options__field--checkbox" type="checkbox" id="{{ survey }}" name="exportSurveyTypesList" ngDefaultControl [formControlName]="survey"/>
                    <span class="uscb-core-form-checkbox"></span>
                    <span class="cmp-form-options__field-description uscb-padding-LR-10">{{ survey }}</span>
                </label>
              <hr class="survey-selection-divider" role="presentation" />
            </div>
            }
        </fieldset>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="request-extension-dialog-actions uscb-layout-row-gt-md uscb-layout-column-md uscb-layout-column-sm uscb-layout-align-center-center">
    <button class="uscb-secondary-button uscb-flex-row uscb-margin-LR-10" type="button" mat-dialog-close>Cancel</button>
    @if (exporting()) {
    <ng-container>
        <div class="cursor-progress"> Please wait. Exporting... &nbsp;&nbsp; <i class="fa fa-spinner fa-spin fa-lg"></i>
        </div>
    </ng-container>
    }
    @if (!exporting()) {
    <ng-container>
        <button class="uscb-primary-button uscb-flex-row uscb-margin-LR-10" type="button" (click)="submit()">Submit</button>
    </ng-container>
    }
  </mat-dialog-actions>

</section>